// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__2VjtC","col":"Table_col__2g8lV","fulfillmentStatus":"Table_fulfillmentStatus__3MDSI","emailCol":"Table_emailCol__2aCyL"};